import React, {useState} from 'react'
import { Modal, Row, Col } from "react-bootstrap"
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

function ScratchCardFilter({show, onHide, filterScratchCard}) {

    const filterSc = () => {
        // let SCFilters = {
        //     referralRewardsTypeId: scReward,
        //     scratchCardStatus: scStatus,
        //     scratchCardGeo: scStatus
        // }
        // Object.keys(SCFilters).forEach((key) => (SCFilters[key].length === 0) && delete SCFilters[key])
        filterScratchCard(scReward, scStatus)
        onHide();
    }

    const close = () => {
        filterScratchCard([], [])
        onHide();
    }

    const [reward, setReward] = useState(false)
    const [scReward, setscReward] = useState([])
    const [virtualCurrency, setVirtualCurrency] = useState(false)
    const [Cashback, setCashback] = useState(false)
    const [Voucher, setVoucher] = useState(false)
    const [Inventory, setInventory] = useState(false)

    const onRewardType = () => {
        setReward(!reward)
    }

    const onscRewardType = (e) => {
        let scRewardList = [...scReward]
        if(e.target.checked){
            if(e.target.value == 1) {
                setscReward([...scReward, e.target.value])
                setVirtualCurrency(!virtualCurrency)
            }else if(e.target.value == 2){
                setscReward([...scReward, e.target.value])
                setCashback(!Cashback)
            }else if(e.target.value == 3){
                setscReward([...scReward, e.target.value])
                setVoucher(!Voucher)
            }
            else if(e.target.value == 4){
                setscReward([...scReward, e.target.value])
                setInventory(!Inventory)
            }
        }else{
            if(e.target.value == 1) {
                setVirtualCurrency(!virtualCurrency)
            }else if(e.target.value == 2){
                setCashback(!Cashback)
            }else if(e.target.value == 3){
                setVoucher(!Voucher)
            }
            else if(e.target.value == 4){
                setInventory(!Inventory)
            }
            scRewardList.splice(scReward.indexOf(e.target.value), 1)
            setscReward(scRewardList)
        }
    }


    const [status, setStatus] = useState(false)
    const [scStatus, setscStatus] = useState([])
    const [yetStart, setYetStart] = useState(false)
    const [Active, setActive] = useState(false)
    const [Deactive, setDeactive] = useState(false)

    const onStatus = () => {
        setStatus(!status)
    }

    const onSCStatus = (e) => {
        let scStatusList = [...scStatus]
        if(e.target.checked){
            if(e.target.value == 'yet to start'){
                setscStatus([...scStatus, e.target.value])
                setYetStart(!yetStart)
            }else if(e.target.value == 'active'){
                setscStatus([...scStatus, e.target.value])
                setActive(!Active)
            }else if(e.target.value == 'inactive'){
                setscStatus([...scStatus, e.target.value])
                setDeactive(!Deactive)
            }
        }else{
            if(e.target.value == 'yet to start'){
                setYetStart(!yetStart)
            }else if(e.target.value == 'active'){
                setActive(!Active)
            }else if(e.target.value == 'inactive'){
                setDeactive(!Deactive)
            }
            scStatusList.splice(scStatus.indexOf(e.target.value), 1)
            setscStatus(scStatusList)
        }
    }

    const [country, setCountry] = useState(false)
    const [scCountry, setscCountry] = useState([])
    const [india, setIndia] = useState(false);
    const onCountry = () => {
        setCountry(!country)
    }

    const onscCountry = (e) => {
        let scCountryList = [...scCountry]
        if(e.target.checked){
            if(e.target.value == 1){
                setscCountry([...scCountry, e.target.value])
                setIndia(!india)
            }
        }else{
            if(e.target.value == 1){
                setIndia(!india)
            }
            scCountryList.splice(scStatus.indexOf(e.target.value), 1)
            setscCountry(scCountryList)
        }
    }

    return (
        <div>
            <Modal centered show={show} onHide={onHide} size="xl" aria-labelledby="contained-modal-title-vcenter" className='filter-main'>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                <p className='heading-title'>Add Filter</p>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Row className="justify-content-center">
                    <Col>
                        <Row className='my-2'>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <label className='filter-title'>Reward Type</label>
                                {/* <FormControlLabel control={<Checkbox checked={reward} onChange={onRewardType} sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />} label="Reward Type" /> */}
                            </Col>
                        </Row>
                        <div className='my-2'>
                            <Row>
                                <Col xs={12} sm={12} md={4} lg={4}>
                                    <FormControlLabel control={<Checkbox checked={virtualCurrency} onChange={(e)=>{onscRewardType(e)}} sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} value={1} />} label={<span style={{ fontSize: '14px' }}>Bonus Cash</span>}/>
                                </Col>
                                <Col xs={12} sm={12} md={4} lg={4}>
                                    <FormControlLabel control={<Checkbox checked={Cashback} onChange={(e)=>{onscRewardType(e)}} sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} value={2} />} label={<span style={{ fontSize: '14px' }}>Virtual Cashback</span>}/>
                                </Col>
                                <Col xs={12} sm={12} md={4} lg={4}>
                                    <FormControlLabel control={<Checkbox checked={Voucher} onChange={(e)=>{onscRewardType(e)}} sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} value={3} />} label={<span style={{ fontSize: '14px' }}>Inventory Reward</span>} />
                                </Col>
                            </Row>
                        </div>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                {/* <FormControlLabel control={<Checkbox checked={status} onChange={onStatus} sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />} label="Coupon Status" /> */}
                                <label className='filter-title'>Coupon Status</label>
                            </Col>
                        </Row>

                            <div className='my-2'>
                                <Row>
                                    <Col xs={12} sm={12} md={4} lg={4}>
                                        <FormControlLabel control={<Checkbox checked={yetStart} onChange={(e)=>{onSCStatus(e)}} value="yet to start" sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />} label={<span style={{ fontSize: '14px' }}>Yet to Start</span>} />
                                    </Col>
                                    <Col xs={12} sm={12} md={4} lg={4}>
                                        <FormControlLabel control={<Checkbox checked={Active} onChange={(e)=>{onSCStatus(e)}} value="active" sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />} label={<span style={{ fontSize: '14px' }}>Active</span>}/>
                                    </Col>
                                    <Col xs={12} sm={12} md={4} lg={4}>
                                        <FormControlLabel control={<Checkbox checked={Deactive} onChange={(e)=>{onSCStatus(e)}} value="inactive" sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />} label={<span style={{ fontSize: '14px' }}>Inctive</span>}/>
                                    </Col>
                                </Row>
                            </div>

                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                {/* <FormControlLabel control={<Checkbox checked={country} onChange={onCountry} sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />} label="Country" /> */}
                                <label className='filter-title'>Country</label>
                            </Col>
                        </Row>
                            <Row className='my-2'>
                                <Col xs={12} sm={12} md={4} lg={4}>
                                    <FormControlLabel control={<Checkbox checked={india} onChange={onscCountry} value={1} sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />} label={<span style={{ fontSize: '14px' }}>Active</span>} />
                                </Col>
                            </Row>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer className='filter-footer'>
                <Row>
                    <Col className="text-right mt-2">
                        <button className="btn btn-md btn-danger mx-2" onClick={filterSc}>Apply Filter</button>
                        <button className="btn btn-md btn-success" onClick={close}>Cancel</button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
        </div>
    )
}

export default ScratchCardFilter